var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "#3D9635"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_42706)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75658 6.21543C9.72358 6.67243 9.68161 7.48143 10.0706 7.56343C10.5406 7.60643 10.2816 6.76645 10.4506 6.61445C10.4826 6.54045 10.5426 6.54044 10.5476 6.63444V7.34944C10.5446 7.57944 10.6956 7.64643 10.8156 7.69343C10.9386 7.68543 11.0206 7.68944 11.0686 7.81044C11.0886 8.22044 11.1076 8.63045 11.1266 9.04045C11.1266 9.04045 11.4136 9.12644 11.4276 8.34944C11.4406 7.89244 11.3366 7.51344 11.3976 7.42344C11.3996 7.33744 11.5096 7.32945 11.5886 7.37645C11.7116 7.46245 11.7666 7.56743 11.9566 7.52443C12.2476 7.44243 12.4206 7.30545 12.4256 7.07945C12.4086 6.86845 12.3856 6.65342 12.2946 6.44242C12.3076 6.40342 12.2366 6.30543 12.2516 6.26643C12.3036 6.34843 12.3816 6.34043 12.3986 6.26643C12.3506 6.10243 12.2736 5.95044 12.1496 5.87944C12.0456 5.78944 11.8936 5.80944 11.8386 6.00044C11.8166 6.21144 11.9186 6.47343 12.0776 6.68443C12.1106 6.76643 12.1566 6.90345 12.1366 7.02845C12.0526 7.07145 11.9696 7.05543 11.8996 6.98143C11.8996 6.98143 11.6666 6.80543 11.6666 6.77043C11.7286 6.37543 11.6816 6.32943 11.6466 6.21943C11.6236 6.07143 11.5496 6.02044 11.4936 5.92244C11.4356 5.85644 11.3576 5.85644 11.3206 5.92244C11.2176 6.09844 11.2646 6.47743 11.3396 6.64943C11.3916 6.80543 11.4746 6.90345 11.4366 6.90345C11.4046 6.99345 11.3386 6.96945 11.2906 6.86845C11.2226 6.65745 11.2106 6.34145 11.2106 6.20045C11.1886 6.02445 11.1656 5.64944 11.0506 5.55244C10.9806 5.45844 10.8746 5.50544 10.8376 5.59544C10.8306 5.76744 10.8306 5.94344 10.8496 6.10344C10.9306 6.38444 10.9526 6.63444 10.9926 6.92344C11.0026 7.31044 10.7696 7.09143 10.7796 6.89643C10.8346 6.65043 10.8176 6.25543 10.7716 6.15843C10.7336 6.05643 10.6886 6.03345 10.5946 6.05345C10.5206 6.04545 10.3316 6.25245 10.2796 6.59645C10.2796 6.59645 10.2336 6.77245 10.2156 6.93245C10.1886 7.10845 10.0716 7.23344 9.99059 6.90544C9.91659 6.66444 9.87458 6.07843 9.75658 6.21543Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0336 8.09052C10.6186 8.29752 10.2166 8.48551 9.80762 8.68051C9.82462 8.40351 10.3916 7.90351 10.7776 7.89551C11.0296 7.90251 10.9656 7.99252 11.0336 8.09052Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5961 5.504C12.5731 5.504 12.5471 5.52001 12.5181 5.52701C12.4181 5.55401 12.3231 5.64401 12.3541 5.81201C12.4721 6.53101 12.5471 7.07799 12.6661 7.79199C12.6861 7.87799 12.6141 7.98701 12.5241 7.98001C12.3691 7.87501 12.3311 7.65999 12.0671 7.67099C11.8761 7.67499 11.6581 7.88199 11.6291 8.08099C11.6001 8.24099 11.5871 8.41299 11.6291 8.54999C11.7651 8.71399 11.9281 8.695 12.0671 8.659C12.1821 8.612 12.2791 8.495 12.3201 8.522C12.3451 8.569 12.3161 8.944 11.7741 9.229C11.4391 9.377 11.1741 9.41701 11.0311 9.14301C10.9441 8.97101 11.0381 8.32301 10.8211 8.47101C10.1751 10.135 12.3311 10.369 12.5721 8.54099C12.5881 8.48998 12.6361 8.43899 12.6701 8.45099C12.6871 8.45899 12.6971 8.478 12.7011 8.517C12.6511 10.169 11.0351 10.279 10.7611 9.763C10.6911 9.638 10.6711 9.36801 10.6641 9.20401C10.6511 9.10201 10.6261 9.04399 10.5981 9.01999C10.5331 8.97299 10.4451 9.10201 10.4251 9.32501C10.3981 9.50501 10.4051 9.55499 10.4051 9.72299C10.4911 11.036 12.5731 10.473 12.9131 9.39099C13.0791 8.83199 12.9091 8.41399 12.9661 8.35999C12.9661 8.35999 12.9671 8.35999 12.9691 8.35999C12.9691 8.35999 12.9691 8.35999 12.9711 8.35999H12.9731C12.9751 8.35999 12.9781 8.35599 12.9781 8.35599C13.1891 8.57899 13.4761 8.38299 13.5411 8.30899C13.5701 8.26999 13.6371 8.246 13.6861 8.293C13.8461 8.41 14.1291 8.35601 14.1881 8.15201C14.2211 7.95301 14.2511 7.74601 14.2581 7.53101C14.1501 7.56201 14.0671 7.59 14.0331 7.625C14.0251 7.633 14.0181 7.64501 14.0161 7.65601C14.0081 7.71101 13.9991 7.773 13.9901 7.832C13.9901 7.836 13.9861 7.84399 13.9851 7.84799C13.9811 7.85599 13.9721 7.86001 13.9641 7.86401C13.9271 7.88701 13.8641 7.87199 13.8591 7.81699C13.8101 7.59399 13.6051 7.55901 13.4801 7.91101C13.3941 7.98101 13.2441 7.99299 13.2271 7.89499C13.2481 7.65699 13.1521 7.62499 12.9611 7.73499C12.9001 7.26599 12.8381 6.82099 12.7761 6.35199C12.8571 6.35199 12.9271 6.41101 13.0021 6.32101C12.9231 6.07501 12.7571 5.57502 12.6631 5.52802H12.6611C12.6571 5.52402 12.6511 5.51599 12.6461 5.51199C12.6461 5.51199 12.6421 5.512 12.6401 5.508C12.6381 5.508 12.6361 5.508 12.6341 5.508C12.6301 5.504 12.6241 5.504 12.6231 5.5C12.6131 5.504 12.6041 5.5 12.5961 5.504ZM12.0171 8.07001C12.0571 8.06601 12.1061 8.08201 12.1311 8.14001C12.1481 8.19101 12.1311 8.24201 12.1071 8.26501C12.1071 8.26501 12.1071 8.26501 12.1051 8.26501C12.0881 8.29201 12.0341 8.28101 11.9931 8.28101C11.9431 8.28101 11.9201 8.26901 11.8911 8.23001C11.8761 8.18701 11.9171 8.14401 11.9371 8.10901C11.9371 8.10901 11.9371 8.10901 11.9391 8.10901C11.9411 8.10901 11.9431 8.10098 11.9461 8.09698C11.9631 8.08598 11.9871 8.07401 12.0171 8.07001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0467 5.46482C13.9917 5.46882 13.9427 5.48482 13.9007 5.50382C13.7937 5.60882 13.7687 5.76982 13.8517 5.87482C13.9337 5.90982 14.0157 5.99583 13.9597 6.03883C13.7297 6.28483 13.1257 6.69883 13.0957 6.77683V6.78083C13.0977 6.78083 13.0977 6.78483 13.0977 6.78483H13.0997H13.1007H13.1027C13.1337 6.80783 13.5097 6.80783 13.5527 6.78883V6.78483C13.6827 6.73783 14.2977 6.03483 14.2977 6.03483C14.2677 6.00783 14.2367 5.98782 14.2047 5.96082C14.1707 5.93382 14.1737 5.90182 14.2047 5.87482C14.3557 5.78482 14.3087 5.58982 14.2297 5.49982C14.1647 5.46882 14.1017 5.46082 14.0467 5.46482ZM14.0187 5.67982C14.0567 5.67582 14.1007 5.71482 14.1227 5.76182C14.1467 5.81282 14.1347 5.86382 14.0977 5.87482C14.0587 5.88282 14.0087 5.84782 13.9837 5.79682C13.9597 5.74182 13.9727 5.69182 14.0117 5.68382C14.0137 5.68382 14.0147 5.67982 14.0187 5.67982Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85188 9.27001C9.62288 9.63701 9.6019 10.184 9.7289 10.348C9.7959 10.426 9.90688 10.461 9.98988 10.434C10.1329 10.371 10.1979 10.079 10.1629 9.97301C10.1149 9.89501 10.0769 9.88303 10.0279 9.95003C9.92791 10.153 9.8849 10.013 9.8759 9.89501C9.8589 9.67601 9.88091 9.47701 9.90291 9.31701C9.92791 9.15601 9.90188 9.20301 9.85188 9.27001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6821 8.68443C19.4611 8.20443 19.1531 7.73143 19.0551 7.55143C18.9561 7.36743 18.2171 6.29743 18.1081 6.17243C17.8671 5.88743 18.4991 6.29343 18.0281 5.72343C17.8501 5.57143 17.8401 5.56342 17.6881 5.43842C17.6161 5.38342 17.4301 5.29045 17.4001 5.44645C17.3821 5.59145 17.3911 5.66945 17.4161 5.78645C17.4351 5.86445 17.5491 6.00145 17.6051 6.07545C18.3561 7.08345 19.0211 8.09844 19.6631 9.38044C19.7641 9.33244 19.7421 8.76643 19.6821 8.68443Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7072 10.2849C18.6622 10.3319 18.8132 10.5469 19.0122 10.5429C19.3412 10.5079 19.6322 10.3199 19.9002 9.83189C19.9712 9.71889 20.0992 9.4769 20.1032 9.2849C20.1262 8.1799 20.0472 7.31991 19.8812 6.51891C19.8692 6.44091 19.8762 6.3509 19.8892 6.3279C19.9112 6.3009 19.9832 6.32791 20.0212 6.26491C20.0792 6.20591 19.8732 5.72988 19.7552 5.54588C19.7132 5.46388 19.6982 5.40888 19.6292 5.55388C19.5572 5.67488 19.5072 5.88589 19.5142 6.07689C19.6712 7.16289 19.7192 8.11989 19.8242 9.20589C19.8312 9.31089 19.8172 9.4679 19.7472 9.5259C19.4862 9.8009 19.1122 10.1329 18.7072 10.2849Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1602 10.2773C22.9222 10.4143 22.9221 10.5743 23.1151 10.5783C23.4451 10.5393 23.8352 10.5123 24.1042 10.1053C24.1752 9.99232 24.2602 9.68331 24.2632 9.49631C24.2882 8.39131 24.2492 7.3083 24.0842 6.5083C24.0732 6.4343 24.0362 6.2543 24.0512 6.2273C24.0732 6.1763 24.1802 6.2353 24.2162 6.1723C24.2752 6.1173 23.9412 5.68431 23.8212 5.50031C23.7812 5.41831 23.7661 5.3633 23.6971 5.5123C23.6231 5.6293 23.5992 5.84432 23.6292 6.03232C23.8032 7.21632 23.9341 8.36032 23.9601 9.40732C23.9461 9.50932 23.9402 9.5633 23.8942 9.6843C23.7922 9.8213 23.6761 9.9853 23.5721 10.0633C23.4631 10.1413 23.2342 10.2193 23.1602 10.2773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3363 9.2187C23.3323 8.9417 23.3443 8.70271 23.3323 8.49571C23.3233 8.29271 23.2283 7.51572 23.1983 7.35072C23.1663 7.18272 23.1333 6.93271 23.0883 6.73371C23.0713 6.65571 23.0323 6.40569 23.0473 6.38169C23.0653 6.32669 23.1413 6.3857 23.1753 6.3187C23.2313 6.2597 22.9893 5.6307 22.8643 5.4517C22.8213 5.3697 22.7393 5.3967 22.6413 5.5297C22.5463 5.6157 22.5813 5.8107 22.6173 5.9987C22.8543 7.2327 23.0313 8.5257 22.9933 9.7057C22.9783 9.8047 23.3403 9.4057 23.3363 9.2187Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5902 7.68771C21.4412 7.68371 21.1282 7.39871 21.0372 7.23071C21.0032 7.13271 21.0272 7.03971 21.0552 6.98471C21.1112 6.94971 21.1962 6.90673 21.2582 6.94973C21.2582 6.94973 21.3242 7.03972 21.3122 7.05172C21.3932 7.09072 21.4282 7.06773 21.4372 7.03173C21.4422 6.97673 21.4122 6.94173 21.4122 6.87973C21.4462 6.70373 21.6442 6.68073 21.7202 6.78973C21.7752 6.85573 21.7952 6.99672 21.8032 7.09472C21.8012 7.14572 21.7222 7.08672 21.6772 7.09872C21.6302 7.11072 21.6202 7.16173 21.6162 7.20773C21.6052 7.33573 21.5922 7.53471 21.5902 7.68771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8421 9.52702C18.8841 9.14802 18.8281 8.38202 18.8241 8.16002C18.8101 7.63702 18.7221 6.62501 18.6831 6.45701C18.6361 6.13701 18.8131 6.49201 18.7881 6.30501C18.7311 5.98901 18.5561 5.774 18.3481 5.481C18.2821 5.387 18.2841 5.36801 18.1801 5.50401C18.0671 5.76201 18.1651 5.942 18.1941 6.145C18.3431 6.801 18.4311 7.40701 18.4711 8.00401C18.5121 8.60201 18.5251 9.348 18.4881 9.981C18.6001 9.98 18.7791 9.79702 18.8421 9.52702Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8439 8.92189C23.5829 8.48089 23.1859 7.9649 23.0799 7.7889C22.9729 7.6129 22.0779 6.30089 21.9659 6.18389C21.6379 5.84389 22.1159 6.12888 21.9049 5.85988C21.7239 5.66488 21.6709 5.60188 21.5169 5.48488C21.4409 5.43788 21.3929 5.3399 21.3679 5.5009C21.3579 5.6459 21.3469 5.80989 21.3559 5.93089C21.3559 6.00089 21.4239 6.12189 21.4869 6.19689C22.2769 7.17389 23.1449 8.36489 23.8409 9.61489C23.9399 9.56589 23.9049 8.99989 23.8439 8.92189Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.666 14.1211H20.664C20.432 14.1801 20.439 14.4221 20.59 14.5271C18.138 14.5271 14.375 14.4881 13.571 14.4881C13.118 14.4881 11.691 14.4331 11.665 14.4331C11.97 14.8781 12.414 14.9681 12.993 14.9801C14.083 14.9801 19.127 14.9681 20.56 14.9681C20.459 15.1481 20.57 15.4371 20.651 15.4911C20.653 15.4911 20.655 15.4951 20.657 15.4951C20.66 15.4991 20.662 15.4991 20.666 15.4991H20.67C20.766 15.5221 20.808 15.4521 20.841 15.4051C20.992 15.4171 21.861 15.4281 21.942 15.4011C21.996 15.4791 22.05 15.5531 22.152 15.5421C22.331 15.5031 22.471 15.4831 22.477 15.1201C22.477 15.1201 22.458 14.5031 22.052 14.5421C21.955 14.5541 21.687 14.5811 21.687 14.5811C21.374 14.5461 21.144 14.5421 20.794 14.5261C20.827 14.4871 20.883 14.3191 20.814 14.2601C20.796 14.2441 20.769 14.2371 20.73 14.2371H20.726H20.723C20.721 14.2371 20.717 14.2331 20.715 14.2291C20.715 14.2291 20.714 14.2291 20.714 14.2251C20.696 14.2051 20.686 14.1391 20.675 14.1201H20.673H20.669H20.666V14.1211ZM20.832 15.0041C20.832 15.0041 20.832 15.0041 20.834 15.0041C21.189 15.0201 21.525 15.0081 21.885 15.0241C21.942 15.0751 21.912 15.1841 21.875 15.2041C21.875 15.2081 21.87 15.2081 21.87 15.2081H21.866C21.862 15.2081 21.86 15.2081 21.86 15.2081C21.744 15.2041 21.677 15.2041 21.561 15.2001C21.561 15.1921 21.557 15.1881 21.557 15.1801C21.529 15.0981 21.33 15.1061 21.283 15.1721H21.281L21.279 15.1761C21.279 15.1761 21.278 15.1801 21.276 15.1841C21.276 15.1841 21.276 15.1881 21.276 15.1921C21.274 15.1961 21.274 15.2001 21.274 15.2041C21.117 15.2201 20.976 15.2001 20.817 15.1881C20.773 15.1331 20.778 15.0311 20.832 15.0041Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4624 5.83986C14.2244 6.51986 14.6004 7.26987 14.8604 7.19887C15.0484 7.27287 15.1674 6.91387 15.2454 6.52287C15.2994 6.41387 15.3384 6.40187 15.3654 6.45687C15.3574 6.97987 15.4024 7.09786 15.5364 7.25386C15.8364 7.48386 16.0844 7.28486 16.1014 7.26186C16.1214 7.24586 16.3344 7.03188 16.3344 7.03188C16.3844 6.97688 16.4534 6.97285 16.5284 7.02385C16.5974 7.08685 16.5894 7.19985 16.7414 7.27385C16.8684 7.32885 17.1414 7.28986 17.2064 7.17586C17.2924 7.03086 17.3104 6.98086 17.3504 6.92586C17.4134 6.84386 17.5154 6.87887 17.5154 6.90587C17.5064 6.95287 17.4484 6.99587 17.4864 7.07787C17.5604 7.13287 17.5774 7.09786 17.6214 7.08586C17.7724 7.01186 17.8874 6.68386 17.8874 6.68386C17.8924 6.55886 17.8244 6.57086 17.7784 6.59786C17.7214 6.63286 17.7174 6.64486 17.6594 6.67986C17.5864 6.68786 17.4414 6.73886 17.3724 6.62886C17.2984 6.49586 17.2984 6.30886 17.2414 6.17586C17.2414 6.16786 17.1454 5.96887 17.2354 5.95287C17.2794 5.96087 17.3754 5.98787 17.3914 5.90587C17.4394 5.82787 17.2894 5.60087 17.1884 5.49187C17.0984 5.39387 16.9754 5.38288 16.8584 5.47988C16.7764 5.55388 16.7874 5.64385 16.7704 5.72185C16.7504 5.81585 16.7554 5.92885 16.8494 6.04985C16.9324 6.21385 17.0834 6.42485 17.0334 6.71785C17.0334 6.71785 16.9444 6.85885 16.7914 6.84285C16.7284 6.82685 16.6234 6.79988 16.5674 6.39388C16.5274 6.08088 16.5794 5.64387 16.4464 5.44487C16.3984 5.31987 16.3654 5.19887 16.2494 5.41387C16.2164 5.49587 16.0854 5.62086 16.1814 5.87886C16.2594 6.04286 16.2924 6.30485 16.2554 6.60185C16.2014 6.68785 16.1894 6.71486 16.1164 6.80086C16.0144 6.90586 15.9064 6.87886 15.8224 6.83986C15.7424 6.78486 15.6814 6.75786 15.6464 6.59386C15.6514 6.32386 15.6654 5.88686 15.6174 5.79286C15.5474 5.64486 15.4274 5.69887 15.3774 5.74187C15.1314 5.96487 15.0094 6.34388 14.9364 6.64388C14.8684 6.86288 14.7944 6.79986 14.7454 6.70986C14.6204 6.59786 14.6114 5.69086 14.4624 5.83986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.269 7.25003C15.268 7.25403 15.266 7.25403 15.262 7.25403L15.26 7.25803C15.244 7.26603 15.224 7.29304 15.183 7.32404C15.112 7.40604 15.102 7.46103 15.106 7.61703C15.109 7.63703 15.237 7.99203 15.347 8.24603C15.42 8.51203 15.49 8.80902 15.439 9.09402C15.268 9.46902 14.919 9.80102 14.585 9.98502C14.413 10.04 14.268 10.024 14.228 9.98502V9.98102C14.128 9.91802 14.126 9.80105 14.131 9.77805H14.133C14.414 9.57905 14.74 9.42302 14.992 8.89102C15.065 8.68802 15.089 8.56703 15.015 8.25003C14.985 8.13703 14.947 8.03903 14.869 7.95703C14.869 7.95703 14.871 7.95703 14.871 7.95303C14.919 7.93003 15.043 8.02303 15.063 7.96503C15.033 7.81303 14.931 7.61302 14.817 7.51202C14.715 7.41802 14.607 7.41003 14.513 7.49203C14.41 7.55103 14.389 7.75804 14.437 7.94104C14.493 8.07404 14.644 8.09703 14.752 8.37103V8.37503C14.754 8.39103 14.787 8.58203 14.733 8.66003C14.689 8.79703 14.129 9.23802 14.089 9.26202L14.085 9.26602C14.085 9.26602 14.085 9.26602 14.085 9.27002H14.083H14.082H14.08H14.078C14.078 9.26602 14.076 9.26602 14.076 9.26602C14.076 9.25402 14.08 9.22303 14.076 9.17603C14.074 9.09803 14.107 8.91003 14.105 8.87503H14.103V8.87103H14.101C13.917 8.99203 13.855 9.35902 13.821 9.46902C13.352 9.78902 12.821 10.032 12.514 10.364C12.354 10.61 13.615 10.075 13.76 10.012C13.762 10.012 13.764 10.012 13.766 10.016C13.793 10.043 13.793 10.149 13.878 10.246C14.01 10.426 14.287 10.535 14.558 10.469C15.012 10.305 15.274 9.99202 15.542 9.64902C15.579 9.59402 15.64 9.55102 15.693 9.59402C15.876 10.004 16.404 10.293 17.087 10.324C17.244 10.133 17.17 10.035 17.105 10C17.085 9.98403 16.765 9.85904 16.716 9.73404C16.686 9.62104 16.76 9.51904 16.913 9.44104C17.349 9.39004 17.782 9.32804 18.199 9.19504C18.202 9.05404 18.285 8.84303 18.34 8.75403C18.379 8.69103 18.404 8.68403 18.413 8.67603C18.413 8.67603 18.415 8.67603 18.415 8.67203C18.417 8.67203 18.417 8.67203 18.417 8.67203V8.66803C18.417 8.66803 18.417 8.66403 18.415 8.66003L18.343 8.61703L16.946 8.60904C16.929 8.60504 16.916 8.59302 16.907 8.58902H16.906C16.906 8.58502 16.906 8.58502 16.906 8.58502H16.904L16.902 8.58102H16.9V8.57703V8.57303V8.56903C16.9 8.56503 16.902 8.56503 16.902 8.56503C16.909 8.55303 16.926 8.54502 16.946 8.53802C17.282 8.49502 17.874 8.39703 17.912 7.82303C17.907 7.52603 17.787 7.33503 17.421 7.28003C17.153 7.30303 16.963 7.56104 16.992 7.84604C16.98 7.92004 17.019 8.07304 16.941 8.08804C16.426 8.13904 15.866 8.45903 15.845 8.69003H15.844H15.84H15.838L15.834 8.69403H15.833H15.831H15.829H15.827L15.821 8.69003C15.788 8.68203 15.745 8.62704 15.753 8.54904C15.733 8.15104 15.603 7.70103 15.399 7.35403C15.328 7.28003 15.295 7.25202 15.274 7.24902H15.272H15.268H15.269V7.25003ZM17.311 7.76202C17.344 7.75802 17.383 7.76603 17.42 7.78903C17.477 7.82003 17.51 7.86704 17.506 7.90604V7.91003V7.91403H17.504C17.504 7.91803 17.502 7.91803 17.502 7.91803V7.92203C17.499 7.92203 17.497 7.92602 17.493 7.93002C17.466 7.95702 17.406 7.95303 17.347 7.91803C17.292 7.88703 17.258 7.83602 17.261 7.80502V7.80103C17.263 7.79303 17.265 7.78903 17.267 7.78903C17.269 7.78503 17.269 7.78504 17.271 7.78104C17.273 7.77704 17.274 7.77704 17.278 7.77304C17.285 7.76604 17.3 7.76202 17.311 7.76202ZM16.012 8.94104C16.016 8.94104 16.022 8.94104 16.027 8.94104H16.029C16.184 8.98404 16.415 8.98802 16.614 9.00702C16.776 9.01902 16.856 9.14403 16.705 9.19803C16.556 9.24903 16.411 9.28802 16.411 9.50702C16.429 9.61202 16.427 9.67104 16.409 9.69504C16.409 9.69904 16.405 9.70303 16.403 9.70303C16.403 9.70303 16.403 9.70303 16.403 9.70703H16.402H16.4V9.71103H16.396C16.394 9.71103 16.391 9.71503 16.389 9.71503C16.387 9.71903 16.383 9.71902 16.383 9.71902C16.346 9.72302 16.294 9.68403 16.254 9.66803C16.164 9.59803 15.903 9.44102 15.866 9.09402C15.861 9.01602 15.92 8.94904 16.012 8.94104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5191 5.84801C11.6811 5.92201 11.9831 5.89102 11.9701 5.63302C11.9701 5.61002 11.9651 5.53101 11.9631 5.51201C11.9321 5.43401 11.8401 5.44903 11.8201 5.53203C11.8131 5.55503 11.8301 5.59803 11.8071 5.61403C11.7921 5.62603 11.7421 5.61802 11.7431 5.54802C11.7431 5.52502 11.7271 5.49701 11.7171 5.48501C11.7081 5.47701 11.701 5.47301 11.681 5.47301C11.66 5.47701 11.66 5.48102 11.65 5.50002C11.642 5.52002 11.637 5.53901 11.637 5.55901C11.633 5.58601 11.6221 5.59401 11.6041 5.59801C11.5861 5.59801 11.5891 5.60202 11.5711 5.59002C11.5621 5.57802 11.5481 5.57401 11.5481 5.55501C11.5481 5.53901 11.5441 5.50402 11.5401 5.49202C11.5301 5.48002 11.517 5.47201 11.5 5.46901C11.411 5.46901 11.4051 5.57101 11.4111 5.61001C11.4021 5.61701 11.3991 5.79701 11.5191 5.84801Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2398 7.84777C16.4008 7.92177 16.7838 7.87878 16.6918 7.62878C16.6918 7.60578 16.6858 7.52677 16.6818 7.50777C16.6498 7.42977 16.5608 7.44879 16.5388 7.52779C16.5338 7.55479 16.5518 7.59779 16.5278 7.61379C16.5138 7.62579 16.4628 7.61379 16.4638 7.54379C16.4638 7.52079 16.4478 7.49676 16.4378 7.48476C16.4278 7.47676 16.4218 7.47277 16.4018 7.47277C16.3808 7.47677 16.3808 7.48078 16.3678 7.49978C16.3638 7.51578 16.3558 7.53477 16.3558 7.55877C16.3528 7.58577 16.3428 7.59377 16.3238 7.59777C16.3038 7.59777 16.3098 7.60178 16.2918 7.58978C16.2808 7.57778 16.2688 7.57377 16.2688 7.55477C16.2688 7.53577 16.2658 7.50378 16.2578 7.49178C16.2498 7.47978 16.2358 7.47177 16.2188 7.46877C16.1318 7.46877 16.1268 7.57076 16.1298 7.60976C16.1248 7.61276 16.1208 7.79277 16.2398 7.84777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9938 7.01969C19.1538 7.09369 19.4568 7.0587 19.4438 6.8007C19.4438 6.7807 19.4388 6.70269 19.4368 6.67969C19.4028 6.60569 19.3118 6.6207 19.2938 6.7027C19.2858 6.7257 19.3028 6.76871 19.2788 6.78071C19.2668 6.79671 19.2148 6.7887 19.2158 6.7147C19.2158 6.6947 19.1998 6.66771 19.1898 6.65171C19.1808 6.64771 19.1738 6.64771 19.1548 6.64771C19.1328 6.64771 19.1328 6.65169 19.1208 6.67069C19.1148 6.69069 19.1078 6.70971 19.1078 6.73371C19.1058 6.75671 19.0958 6.76471 19.0758 6.76871C19.0558 6.76871 19.0588 6.77269 19.0448 6.76069C19.0338 6.75269 19.0218 6.74472 19.0218 6.72572C19.0218 6.70572 19.0157 6.67471 19.0107 6.65971C19.0007 6.65171 18.9877 6.64771 18.9717 6.64371C18.8837 6.64371 18.8768 6.74571 18.8828 6.78071C18.8778 6.78871 18.8738 6.96869 18.9938 7.01969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.419 9.09419C20.139 9.41019 20.262 9.93419 20.325 10.0472C20.419 10.2312 20.493 10.3522 20.672 10.4422C20.838 10.5672 20.965 10.4892 21.035 10.4032C21.199 10.2312 21.203 9.7982 21.279 9.7122C21.335 9.5522 21.469 9.57918 21.536 9.64918C21.602 9.73918 21.678 9.80118 21.771 9.85218C21.924 9.98518 22.109 10.0122 22.289 9.88719C22.414 9.82119 22.495 9.72719 22.565 9.55119C22.648 9.33219 22.603 8.1642 22.586 7.5742C22.578 7.5272 22.427 6.76119 22.427 6.75419C22.427 6.74619 22.406 6.36318 22.39 6.27418C22.386 6.23518 22.377 6.22318 22.416 6.22718C22.457 6.26618 22.461 6.27021 22.487 6.27821C22.528 6.28621 22.565 6.21518 22.541 6.14918C22.414 5.91518 22.284 5.67621 22.156 5.44621C22.127 5.41121 22.086 5.3802 22.036 5.4502C21.99 5.4932 21.94 5.5632 21.942 5.6612C21.954 5.8292 21.983 6.0012 21.994 6.1692C22.046 6.4542 22.097 6.74321 22.148 7.03221C22.196 7.64521 22.209 8.20821 22.257 8.82121C22.249 9.07921 22.17 9.4262 22.091 9.4582C22.091 9.4582 21.979 9.5282 21.901 9.4542C21.843 9.4312 21.619 9.0792 21.619 9.0792C21.504 8.9742 21.427 9.0012 21.345 9.0792C21.118 9.2982 21.019 9.70418 20.865 9.98518C20.824 10.0482 20.713 10.1022 20.59 9.98118C20.273 9.55118 20.459 8.93819 20.419 9.09419Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0658 5.51236C19.2098 5.57136 19.3108 5.86037 19.2778 6.00437C19.2488 6.18037 19.1728 6.37536 19.1178 6.34836C19.0588 6.32536 19.1578 6.17236 19.1018 6.01236C19.0678 5.90736 18.8728 5.71937 18.8928 5.66037C18.8518 5.54337 18.9768 5.48836 19.0658 5.51236Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8839 9.27007C20.9139 8.92207 20.8639 8.70409 20.8539 8.49709C20.8449 8.29409 20.6229 6.61809 20.5759 6.46209C20.5209 6.16909 20.7939 6.42309 20.7619 6.25109C20.6679 6.03609 20.4339 5.72009 20.3619 5.53209C20.3149 5.45009 20.3349 5.38007 20.2349 5.51207C20.1449 5.81307 20.1119 6.05508 20.1459 6.24608C20.3829 7.48008 20.6249 8.60509 20.5879 9.77709C20.6989 9.77709 20.8279 9.52307 20.8839 9.27007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3464 5.92588C23.4814 5.99588 23.5574 6.35988 23.5424 6.46488C23.5174 6.65588 23.4474 6.86288 23.3964 6.83588C23.3424 6.81288 23.4074 6.55087 23.3804 6.47287C23.3494 6.35987 23.1714 6.15288 23.1904 6.08988C23.1544 5.96088 23.2694 5.90588 23.3464 5.92588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.573 8.60504C13.697 8.65204 13.772 8.92103 13.758 9.00003C13.733 9.14103 13.6659 9.28904 13.6189 9.27304C13.5659 9.25304 13.63 9.06202 13.603 9.00302C13.593 8.85802 13.418 8.78402 13.422 8.72202C13.39 8.60902 13.494 8.59004 13.573 8.60504Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2099 5.4225C10.3949 5.4775 10.4059 5.7505 10.3939 5.8325C10.3689 5.9775 10.3019 6.13351 10.2529 6.11351C10.2039 6.09751 10.2519 5.8985 10.2269 5.8365C10.2009 5.7465 10.0429 5.5945 10.0619 5.5475C10.0259 5.4495 10.1329 5.4025 10.2099 5.4225Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8762 6.71086C13.7322 6.78486 13.6792 7.01587 13.7682 7.15187C13.8492 7.26487 13.9821 7.22184 13.9981 7.22184C14.1381 7.24184 14.2212 6.95985 14.2212 6.95985C14.2212 6.95985 14.2252 6.88186 14.0612 7.02986C13.9912 7.04586 13.9822 7.01786 13.9632 6.97886C13.9492 6.90486 13.9511 6.83387 13.9851 6.75987C14.0101 6.69087 13.9562 6.65986 13.8762 6.71086Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9425 5.31614C14.8725 5.36314 14.7285 5.51115 14.7255 5.68315C14.7195 5.77715 14.7025 5.77712 14.7645 5.83912C14.8115 5.90512 14.8575 5.89812 14.9485 5.84712C15.0005 5.81212 15.0174 5.78412 15.0364 5.72212C15.0584 5.61312 14.9225 5.77314 14.9035 5.65214C14.8745 5.53914 14.9615 5.49612 15.0455 5.38212C15.0475 5.30912 15.0455 5.25814 14.9425 5.31614Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8062 5.46919C15.7752 5.53919 15.7382 5.89518 15.7432 5.89518C15.7182 6.00018 15.8552 6.0472 15.9162 5.9112C16.0092 5.6612 16.0092 5.55621 16.0142 5.44621C15.9862 5.28521 15.8772 5.29319 15.8062 5.46919Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2305 8.23036C21.2505 8.21436 21.9955 7.68336 21.9955 7.68336C22.0715 7.65636 22.0555 7.95635 22.0205 7.95335C22.0345 8.01635 21.2845 8.52334 21.2305 8.50434C21.1945 8.52734 21.1575 8.29736 21.2305 8.23036Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.912 8.22732C22.045 8.29332 22.0971 8.67635 22.0821 8.78235C22.0871 8.98535 21.955 9.14934 21.904 9.12634C21.849 9.09934 21.9101 8.87234 21.8841 8.79034C21.8531 8.67734 21.7401 8.46635 21.7601 8.40335C21.7241 8.27335 21.832 8.20332 21.912 8.22732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4744 9.88284C17.5254 9.80884 17.6864 9.69885 17.6864 9.69885C17.7634 9.65985 17.8364 9.72586 17.8314 9.72586C17.8444 9.79586 17.7854 9.86683 17.8044 9.96383C17.8194 10.0028 17.8314 10.0498 17.9044 10.0298C18.0244 9.93584 18.1324 9.92785 18.2514 9.92785C18.3444 9.92785 18.3454 10.0839 18.2894 10.0839C18.0704 10.1309 17.9714 10.1929 17.8154 10.2519C17.7414 10.2949 17.6784 10.2398 17.6784 10.2318C17.6784 10.2278 17.6354 10.1928 17.6644 10.0948C17.6714 10.0168 17.6394 9.97384 17.5724 9.97784C17.5224 10.0088 17.4794 10.0248 17.4554 9.96985C17.4454 9.92985 17.4414 9.90584 17.4744 9.88284Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_42706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 0.664062H0.257812V20.2461H33.8208V0.664062Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_42706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6964 10.0901C22.7274 10.1331 22.7505 10.168 22.6945 10.235C22.6405 10.286 22.6055 10.309 22.5515 10.36C22.5285 10.403 22.5125 10.465 22.5865 10.485C22.7255 10.524 23.0485 10.3171 23.0485 10.3091C23.1035 10.2741 23.0845 10.1961 23.0785 10.1961C23.0485 10.1611 22.9805 10.1801 22.9345 10.1801C22.9115 10.1801 22.8395 10.164 22.8745 10.106C22.9025 10.063 22.9134 10.0401 22.9334 9.99307C22.9544 9.94207 22.9375 9.91106 22.8565 9.88406C22.7785 9.86806 22.7464 9.88006 22.6574 9.88406C22.6094 9.89606 22.5934 9.91906 22.5844 9.97406C22.5874 10.0591 22.6414 10.0551 22.6964 10.0901Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/SAUDI_ARABIA.36b4112591c67708c182933b6bf43bfe.svg";
export { ForwardRef as ReactComponent };